var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4914 4.55984C15.4505 4.55984 14.4901 4.215 13.7188 3.63327C12.8343 2.96639 12.1987 1.98816 11.9743 0.86067C11.9187 0.582092 11.8888 0.294608 11.886 0H8.91245V8.12507L8.90889 12.5755C8.90889 13.7654 8.13407 14.7742 7.06002 15.1291C6.74831 15.232 6.41167 15.2808 6.06113 15.2616C5.61369 15.237 5.1944 15.102 4.82997 14.884C4.05444 14.4201 3.52864 13.5787 3.51439 12.6162C3.49194 11.1118 4.70814 9.88524 6.21146 9.88524C6.50821 9.88524 6.7932 9.93368 7.06002 10.0217V7.80089V7.00256C6.77859 6.96088 6.49218 6.93915 6.20255 6.93915C4.55709 6.93915 3.01815 7.62313 1.91809 8.85535C1.08663 9.78656 0.587894 10.9746 0.510947 12.2204C0.410132 13.8569 1.00897 15.4126 2.1703 16.5604C2.34094 16.7289 2.52013 16.8853 2.70751 17.0296C3.70319 17.7958 4.92046 18.2112 6.20255 18.2112C6.49218 18.2112 6.77859 18.1898 7.06002 18.1482C8.25769 17.9708 9.36274 17.4225 10.2348 16.5604C11.3064 15.5013 11.8984 14.0953 11.9048 12.5987L11.8895 5.95273C12.4007 6.34708 12.9597 6.6734 13.5596 6.92668C14.4926 7.32033 15.4818 7.51982 16.5 7.51946V5.36031V4.55913C16.5007 4.55984 16.4921 4.55984 16.4914 4.55984Z",
    fill: "url(#paint0_linear_123_5708)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_5708",
    x1: 0.5,
    y1: 9.17964,
    x2: 16.5,
    y2: 9.17964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7AC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/tik-tok.f5b601ee38be0e0fb04a09e2b49805dc.svg";
export { ForwardRef as ReactComponent };